import { createFileRoute, Navigate } from '@tanstack/react-router'

/**
 * Data Vault has no landing page of its own, as in VentaHub: the section
 * opens on Products (Listings), the dataset VentaHub's `/data` shows.
 */
export const Route = createFileRoute('/_app/data-vault/')({
  component: () => <Navigate to="/data-vault/products" replace />,
})
